module.exports = __webpack_public_path__ + "./img/menu_logout_hover.png";